import { collectionGroup, DocumentData, Query } from "firebase/firestore";

import { firebase } from "@/core/modules/firebase/objects/Firebase";
import { FirestoreDocument } from "@/core/modules/firestore/objects/FirestoreDocument";
import { FirestoreModel } from "../FirestoreModel";

export const getGroupPathReference = <T extends FirestoreDocument>(model: FirestoreModel<T>): Query<DocumentData> => {
  return collectionGroup(firebase.firestore, model.collectionName);
};
